import {z} from 'zod';

import {usageSchema} from '../common/UsageSchema';

/**
 * Response schema for single usage record
 */
export const getUsageResponseSchema = usageSchema;

export type GetUsageResponse = z.infer<typeof getUsageResponseSchema>;
